module.exports = __webpack_public_path__ + "img/renzheng@3x.3f6e8608.png";